module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": "0.2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "row2 flex-start"
  }, [_c('div', {
    staticClass: "row2-li"
  }, [_c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'DakejianList'
      }),
      expression: "{ name: 'DakejianList' }"
    }],
    attrs: {
      "src": require("../../../assets/images/qcxj/icon-dakejian-large2.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row-tip",
    staticStyle: {
      "color": "#d12adf"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.certRow.dakejian && _vm.certRow.dakejian.length > 0 ?
    "已申报" :
    "未申报") + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "row2-li"
  }, [_c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ClubDetailSihaoApplySuccess'
      }),
      expression: "{ name: 'ClubDetailSihaoApplySuccess' }"
    }],
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230911/user-0/20230911/3b18f8c422e60fb1c43e730c2cfdf893.png"
    }
  }), _vm._v(" "), (_vm.certRow.center_list.length > 0) ? _c('div', {
    staticClass: "row-tip",
    staticStyle: {
      "color": "#57e1ab"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.certRow.sihao) + "位\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row2-li"
  }, [(_vm.certRow.club.id) ? _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ClubDetailMine',
        query: {
          id: _vm.certRow.club.id
        }
      }),
      expression: "{ name: 'ClubDetailMine',query:{\n            id:certRow.club.id\n          } }"
    }],
    attrs: {
      "src": require("../../../assets/images/qcxj/icon-club-large.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.certRow.club_list.length > 0) ? _c('div', {
    staticClass: "row-tip",
    staticStyle: {
      "color": "#50b0ff"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.certRow.club_list.length) + "家\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row4"
  }, [_c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsList',
        query: {
          cate_id: 132
        }
      }),
      expression: "{ name: 'NewsList', query: { cate_id: 132 } }"
    }],
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230911/user-0/20230911/605c88c6da07bd6f29f0ed545b04546e.png"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsList',
        query: {
          cate_id: 133
        }
      }),
      expression: "{ name: 'NewsList', query: {cate_id:133} }"
    }],
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230911/user-0/20230911/ea32bbda7a94e1987c161b089cbe3d87.png"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsList',
        query: {
          cate_id: 134
        }
      }),
      expression: "{ name: 'NewsList', query: { cate_id: 134 } }"
    }],
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230911/user-0/20230911/72806c6294ce4ea3cf60dceb5e368c06.png"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsList',
        query: {
          cate_id: 137
        }
      }),
      expression: "{ name: 'NewsList', query: { cate_id: 137 } }"
    }],
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230911/user-0/20230911/a3716d5569ea93799a4caed8deeaa4ee.png"
    }
  })]), _vm._v(" "), _c('van-tabs', {
    class: _vm.row.bg_show ? 'active-tab' : '',
    attrs: {
      "sticky": ""
    },
    on: {
      "click": _vm.onClick
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, _vm._l((_vm.activeTab), function(item, index) {
    return _c('van-tab', {
      key: index,
      attrs: {
        "type": index
      },
      scopedSlots: _vm._u([{
        key: "title",
        fn: function() {
          return [(item.num > 0) ? _c('span', {
            staticClass: "active-tab-num"
          }, [_vm._v(_vm._s(item.num))]) : _vm._e(), _vm._v("\n            " + _vm._s(item.name) + "\n          ")]
        },
        proxy: true
      }], null, true)
    })
  }), 1), _vm._v(" "), (_vm.sendShow) ? _c('div', {
    staticClass: "comment-bottom"
  }, [_c('div', {
    staticClass: "send-comment"
  }, [_c('van-field', {
    attrs: {
      "placeholder": _vm.placeholder,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "send-btn",
    on: {
      "click": _vm.onCommentSend
    }
  }, [_vm._v("发送")])], 1)]) : _vm._e(), _vm._v(" "), _c('van-pull-refresh', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 2),
      expression: "active==2"
    }],
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.row.list.list), function(item, i) {
    return _c('div', {
      key: i
    }, [(item.style == '-1') ? _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsDetail',
          query: {
            id: item.id
          }
        }),
        expression: "{ name: 'NewsDetail', query: { id: item.id } }"
      }]
    }, [(item.pics.length == 0) ? _c('NewsItem1', {
      attrs: {
        "row": item
      }
    }) : _vm._e(), _vm._v(" "), (item.pics.length == 1) ? _c('NewsItem2', {
      attrs: {
        "row": item
      }
    }) : _vm._e(), _vm._v(" "), (false) ? _c('NewsItem3') : _vm._e(), _vm._v(" "), (item.pics.length > 1) ? _c('NewsItem4', {
      attrs: {
        "row": item
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.style == '1') ? _c('Activity1', {
      attrs: {
        "content": item,
        "index": i
      }
    }) : _vm._e(), _vm._v(" "), (item.style == '2') ? _c('Activity2', {
      attrs: {
        "content": item,
        "index": i
      }
    }) : _vm._e(), _vm._v(" "), (item.style == '3') ? _c('Activity3', {
      attrs: {
        "content": item,
        "index": i
      },
      on: {
        "sendBox": function($event) {
          return _vm.onSendBox($event, item, i)
        },
        "loginStatus": function($event) {
          return _vm.onLoginStatus($event)
        },
        "deleteActive": function($event) {
          return _vm.onDeleteActive($event, item, i)
        },
        "deleteComment": function($event) {
          return _vm.onDeleteComment($event, i)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.style == '4') ? _c('Activity4', {
      attrs: {
        "content": item,
        "index": i
      },
      on: {
        "sendBox": function($event) {
          return _vm.onSendBox($event, item, i)
        },
        "loginStatus": function($event) {
          return _vm.onLoginStatus($event)
        },
        "deleteActive": function($event) {
          return _vm.onDeleteActive($event, item, i)
        },
        "deleteComment": function($event) {
          return _vm.onDeleteComment($event, i)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.style == '5') ? _c('Activity5', {
      attrs: {
        "content": item,
        "index": i
      },
      on: {
        "sendBox": function($event) {
          return _vm.onSendBox($event, item, i)
        },
        "loginStatus": function($event) {
          return _vm.onLoginStatus($event)
        },
        "deleteActive": function($event) {
          return _vm.onDeleteActive($event, item, i)
        },
        "deleteComment": function($event) {
          return _vm.onDeleteComment($event, i)
        }
      }
    }) : _vm._e()], 1)
  }), 0)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 0),
      expression: "active==0"
    }],
    staticClass: "notice",
    domProps: {
      "innerHTML": _vm._s(_vm.notice)
    }
  }), _vm._v(" "), _c('van-cell-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 1),
      expression: "active==1"
    }]
  }, [_c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ClubSearchIndex',
        query: {}
      }),
      expression: "{name: 'ClubSearchIndex',query: {}}"
    }],
    attrs: {
      "title": "搜索更多俱乐部",
      "is-link": ""
    }
  }), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('van-cell', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'ClubDetailUnbind',
          query: {
            id: item.id
          }
        }),
        expression: "{name: 'ClubDetailUnbind',query: {id: item.id}}"
      }],
      key: index,
      staticClass: "flex-start",
      attrs: {
        "value": item.danwei + item.clubleixing,
        "is-link": ""
      },
      scopedSlots: _vm._u([{
        key: "icon",
        fn: function() {
          return [_c('img', {
            staticStyle: {
              "height": "1.2rem",
              "margin-right": ".3rem"
            },
            attrs: {
              "src": item.pic_url,
              "alt": ""
            }
          })]
        },
        proxy: true
      }], null, true)
    })
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 2), _vm._v(" "), _c('NavFloatAdd', {
    attrs: {
      "id": this.aparams.id,
      "back": 1
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03c7d51f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubIndex2.vue
// module id = 2173
// module chunks = 0